import type * as yup from "yup";
import {
  INVESTOR_WIZARD_STEP_FIELDS,
  INVESTOR_WIZARD_STEP_IDS,
  type InvestorWizardFormData,
} from "@/domain/validation/investorSchemas";
import { EMPTY_REPRESENTATIVE } from "@/domain/validation/representativeSchemas";
import { areFieldsValid } from "@/domain/validation/stepValidity";

export const EMPTY_INVESTOR_WIZARD_FORM: InvestorWizardFormData = {
  type: "individual",
  firstName: "",
  lastName: "",
  dni: "",
  birthDate: "",
  profession: "",
  companyName: "",
  cif: "",
  website: "",
  signatureRegime: "sole",
  representative: EMPTY_REPRESENTATIVE,
  email: "",
  phone: "",
  fiscalAddress: "",
  city: "",
  postalcode: "",
  country: "ES",
  language: "es",
  investmentInterests: [],
  taxableIncomeBase: "",
  potentialInvestmentAmount: "",
};

export interface IndividualInvestorWizardValues extends InvestorWizardFormData {
  firstName: string;
  lastName: string;
  dni: string;
}

export interface CompanyInvestorWizardValues extends InvestorWizardFormData {
  companyName: string;
  cif: string;
}

export function hasIndividualInvestorFields(
  data: InvestorWizardFormData,
): data is IndividualInvestorWizardValues {
  return (
    data.type === "individual" &&
    typeof data.firstName === "string" &&
    typeof data.lastName === "string" &&
    typeof data.dni === "string"
  );
}

export function hasCompanyInvestorFields(
  data: InvestorWizardFormData,
): data is CompanyInvestorWizardValues {
  return (
    data.type === "company" && typeof data.companyName === "string" && typeof data.cif === "string"
  );
}

export function isInvestorWizardStepComplete(
  schema: yup.AnyObjectSchema,
  step: number,
  values: InvestorWizardFormData,
): boolean {
  const stepId = INVESTOR_WIZARD_STEP_IDS[step];
  return !!stepId && areFieldsValid(schema, values, INVESTOR_WIZARD_STEP_FIELDS[stepId]);
}
